"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var StartDrag_exports = {};
__export(StartDrag_exports, {
  default: () => StartDrag_default
});
module.exports = __toCommonJS(StartDrag_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.35547 14.2734C7.35547 14.2734 7.5638 14.5729 7.98047 15.1719C8.41016 15.7708 8.73568 16.1875 8.95703 16.4219C9.13932 16.6042 9.3737 16.7474 9.66016 16.8516C9.94661 16.9427 10.2656 16.9883 10.6172 16.9883H13.6641C14.4453 16.9883 15.0052 16.5977 15.3438 15.8164C15.6823 15.0221 15.8841 14.5078 15.9492 14.2734C16.0013 14.0391 16.0534 13.7331 16.1055 13.3555C16.1576 12.9779 16.2031 12.6198 16.2422 12.2812L16.3203 11.6367C16.3724 11.3242 16.3984 10.8815 16.3984 10.3086C16.4115 9.73568 16.4115 9.16276 16.3984 8.58984C16.3854 8.01693 16.3724 7.52214 16.3594 7.10547C16.3333 6.67578 16.3203 6.45443 16.3203 6.44141C16.3203 6.23307 16.2422 6.05729 16.0859 5.91406C15.9427 5.75781 15.7669 5.67969 15.5586 5.67969C15.3503 5.67969 15.168 5.7513 15.0117 5.89453C14.8685 6.03776 14.7969 6.21354 14.7969 6.42188V11.0117C14.7969 11.1159 14.7578 11.207 14.6797 11.2852C14.6146 11.3503 14.5299 11.3828 14.4258 11.3828C14.3216 11.3828 14.2305 11.3503 14.1523 11.2852C14.0742 11.207 14.0352 11.1159 14.0352 11.0117V5.03516C14.0352 4.82682 13.9635 4.65104 13.8203 4.50781C13.6771 4.36458 13.4948 4.29297 13.2734 4.29297C13.0651 4.29297 12.8893 4.36458 12.7461 4.50781C12.6029 4.65104 12.5312 4.82682 12.5312 5.03516V10.3086C12.5312 10.4128 12.4922 10.5039 12.4141 10.582C12.3359 10.6471 12.2448 10.6797 12.1406 10.6797C12.0365 10.6797 11.9453 10.6471 11.8672 10.582C11.8021 10.5039 11.7695 10.4128 11.7695 10.3086V4.25391C11.7695 4.04557 11.6914 3.86979 11.5352 3.72656C11.3919 3.58333 11.2161 3.51172 11.0078 3.51172C10.7995 3.51172 10.6172 3.58333 10.4609 3.72656C10.3177 3.86979 10.2461 4.04557 10.2461 4.25391V10.3086C10.2461 10.4128 10.207 10.5039 10.1289 10.582C10.0508 10.6471 9.95964 10.6797 9.85547 10.6797C9.7513 10.6797 9.66016 10.6471 9.58203 10.582C9.51693 10.5039 9.48438 10.4128 9.48438 10.3086V5.03516C9.48438 4.82682 9.40625 4.65104 9.25 4.50781C9.10677 4.36458 8.93099 4.29297 8.72266 4.29297C8.51432 4.29297 8.33203 4.36458 8.17578 4.50781C8.03255 4.65104 7.96094 4.82682 7.96094 5.03516V10.8945C7.96094 10.9727 7.9349 11.0508 7.88281 11.1289C7.83073 11.194 7.76562 11.2331 7.6875 11.2461C7.59635 11.2721 7.51172 11.2721 7.43359 11.2461C7.35547 11.207 7.29688 11.1484 7.25781 11.0703L6.00781 8.96094C5.90365 8.77865 5.7474 8.66146 5.53906 8.60938C5.34375 8.55729 5.15495 8.58333 4.97266 8.6875C4.79036 8.79167 4.67318 8.94141 4.62109 9.13672C4.56901 9.33203 4.59505 9.52083 4.69922 9.70312L7.35547 14.2734ZM13.6641 17.75H10.6172C10.1615 17.75 9.73828 17.6849 9.34766 17.5547C8.97005 17.4115 8.65755 17.2096 8.41016 16.9492C8.16276 16.6888 7.82422 16.2526 7.39453 15.6406C6.96484 15.0286 6.73698 14.7031 6.71094 14.6641L4.03516 10.0742C3.93099 9.90495 3.86589 9.72266 3.83984 9.52734C3.8138 9.33203 3.82682 9.13672 3.87891 8.94141C3.93099 8.74609 4.01562 8.57031 4.13281 8.41406C4.26302 8.25781 4.41927 8.1276 4.60156 8.02344C4.96615 7.8151 5.35026 7.76953 5.75391 7.88672C6.15755 7.99089 6.46354 8.21875 6.67188 8.57031L7.19922 9.48828V5.03516C7.19922 4.61849 7.34896 4.26693 7.64844 3.98047C7.94792 3.68099 8.30599 3.53125 8.72266 3.53125C8.87891 3.53125 9.02865 3.55729 9.17188 3.60938C9.3151 3.64844 9.44531 3.70703 9.5625 3.78516C9.66667 3.48568 9.84896 3.23828 10.1094 3.04297C10.3698 2.84766 10.6693 2.75 11.0078 2.75C11.3333 2.75 11.6263 2.84766 11.8867 3.04297C12.1602 3.23828 12.349 3.48568 12.4531 3.78516C12.5703 3.70703 12.7005 3.64844 12.8438 3.60938C12.987 3.55729 13.1302 3.53125 13.2734 3.53125C13.7031 3.53125 14.0612 3.68099 14.3477 3.98047C14.6471 4.26693 14.7969 4.61849 14.7969 5.03516V5.13281C14.9141 5.06771 15.0378 5.01562 15.168 4.97656C15.2982 4.9375 15.4284 4.91797 15.5586 4.91797C15.9753 4.91797 16.3333 5.06771 16.6328 5.36719C16.9323 5.65365 17.082 6.00521 17.082 6.42188C17.082 6.46094 17.0951 6.70182 17.1211 7.14453C17.1341 7.57422 17.1471 8.07552 17.1602 8.64844C17.1732 9.22135 17.1732 9.80078 17.1602 10.3867C17.1602 10.9596 17.1341 11.4154 17.082 11.7539L17.0039 12.3789C16.9518 12.7305 16.8997 13.1016 16.8477 13.4922C16.7956 13.8698 16.737 14.1888 16.6719 14.4492C16.5807 14.8398 16.3138 15.4909 15.8711 16.4023C15.4414 17.3008 14.7057 17.75 13.6641 17.75Z",
      fill: "currentColor"
    }
  )
);
const SvgStartDrag = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var StartDrag_default = SvgStartDrag;
